import { Box, Container, useMediaQuery } from '@mui/material';
import * as React from 'react';
interface Props {
  children: React.ReactNode;
}
const Layout: React.FunctionComponent<Props> = (props: Props) => {
  const isDesktop = useMediaQuery('(min-width:900px)');

  return (
    <Box
      sx={(theme) => ({
        height: '100vh',
        width: '100%',
        display: 'flex',
        flex: 1,
        flexFlow: 'column',
        background: theme.palette.background.default,
      })}
      data-testid="container"
    >
      <Container
        maxWidth="xl"
        sx={(theme) => ({
          display: 'flex',
          flexFlow: 'column',
          flex: '1 1 auto',
          height: 0,
          background: theme.palette.background.default,
          ...(!isDesktop ? { padding: '0!important' } : {}),
          paddingTop: { xs: '70px!important', md: '60px' },
          overflow: 'hidden',
        })}
      >
        {props.children}
      </Container>
    </Box>
  );
};

export default Layout;
